var config = null

function getConfig(node) {
  var tmp = node ? JSON.parse(node.content) : {}

  // Clean up variables
  tmp.translationPath && (tmp.translationPath = tmp.translationPath.trim())

  return tmp
}

exports.config = (function(node) {
  if (!config) {
    config = getConfig(document.getElementById('cm-app-config'))
  }
  return config
})()

function set(config){
  var meta = document.getElementById('cm-app-config');
  meta.content = JSON.stringify(config);
}

function get(){
  var meta = getConfig(document.getElementById('cm-app-config'))
  return meta
}
exports.set = set;
exports.get = get;
